// extracted by mini-css-extract-plugin
export default {"block":"NotFound_block__T9Afc","backButton":"NotFound_backButton__DwNFO"};